import { useTranslation } from 'react-i18next'

interface FAQItem {
  questionKey: string
  answerKey: string
}

const getFAQItems = (): FAQItem[] => [
  {
    questionKey: 'createProduct',
    answerKey: 'createProductAnswer'
  },
  {
    questionKey: 'setPermissions',
    answerKey: 'setPermissionsAnswer'
  },
  {
    questionKey: 'viewStats',
    answerKey: 'viewStatsAnswer'
  }
]

export default function FAQCard() {
  const { t } = useTranslation('home')
  const faqItems = getFAQItems()

  return (
    <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-200 hover:shadow-xl transition-all duration-300">
      <div className="flex items-center mb-6">
        <div className="w-12 h-12 bg-primary-50 rounded-lg flex items-center justify-center mr-4">
          <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
          </svg>
        </div>
        <h3 className="text-xl font-bold text-text-dark">{t('faq.title')}</h3>
      </div>
      <p className="text-gray-600 mb-4">
        {t('faq.description')}
      </p>
      <div className="space-y-3">
        {faqItems.map((item, index) => (
          <div key={index} className="border-l-4 border-highlight-orange pl-4">
            <h4 className="font-medium text-text-dark mb-1">{t(`faq.items.${item.questionKey}`)}</h4>
            <p className="text-sm text-gray-600">{t(`faq.items.${item.answerKey}`)}</p>
          </div>
        ))}
      </div>
      <a
        href="https://docs.google.com/document/d/1GY3_gTNkjoPS3XBrCWl10c4uATxiOupCvAeMSVVsfJY/edit?tab=t.xin9hbg2jw6b"
        target="_blank"
        rel="noopener noreferrer"
        className="mt-8 text-highlight-orange hover:text-highlight-orange font-medium inline-block"
      >
        {t('faq.button')}
      </a>
    </div>
  )
}